import { IconProps } from '@shared/ui/Icon/model/types';

export const SendIcon = ({ fill = '#818998', width = 18, height = 18 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M3.13011 9.75464H18L3.1511 17.7659C2.83972 17.9174 2.49846 17.9974 2.15223 18C1.62812 18.0009 1.12289 17.8043 0.737156 17.4492C0.431667 17.1772 0.216379 16.8184 0.120037 16.4207C0.0236953 16.023 0.050884 15.6053 0.197973 15.2235L0.239968 15.1312L3.13011 9.75464ZM3.02587 0.211089C2.64349 0.0260432 2.21429 -0.0394953 1.79416 0.0230097C1.37403 0.0855147 0.982452 0.273166 0.670414 0.561525C0.0412428 1.14083 -0.164232 1.99328 0.135731 2.7887L3.11961 8.25384H17.9985L3.08286 0.241105L3.02587 0.211089Z"
            fill={fill}
        />
    </svg>
);
